import React from 'react'

import ZoomableTableWrapper from '../components/DiseaseDashboard/ZoomableTableWrapper'
import ShrimpSizeDashboard from '../components/ShrimpSizeDashboard'
import useWebviewPageHeight from './useWebviewPageHeight'

// NK-276: the mobile ไซส์กุ้ง tab is this page inside a WebView, mirroring ผลเชื้อ —
// same zoom wrapper, same viewport guards, so pinch-zoom and drag-to-fetch behave
// identically across the two tabs.
const ShrimpSizeTablePage = () => {
  const [isLoading, setIsLoading] = React.useState(false)

  // Pinned height, or 0 to render unconstrained — see the hook for why.
  const pageHeight = useWebviewPageHeight()

  const boundedStyle: React.CSSProperties =
    pageHeight > 0 ? { height: pageHeight, overflow: 'hidden' } : {}

  React.useEffect(() => {
    // Lock the native viewport so the WebView's own pinch/double-tap zoom does not
    // fight ZoomableTableWrapper's custom pinch handler.
    const viewport = document.querySelector('meta[name="viewport"]')
    if (!viewport) return
    const original = viewport.getAttribute('content') ?? ''
    viewport.setAttribute(
      'content',
      'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, shrink-to-fit=no'
    )
    return () => {
      viewport.setAttribute('content', original)
    }
  }, [])

  return (
    <div style={boundedStyle}>
      <ZoomableTableWrapper initialScale={0.5} minScale={0.2} maxScale={1.5} isLoading={isLoading}>
        <ShrimpSizeDashboard setLoadingMobile={setIsLoading} />
      </ZoomableTableWrapper>
    </div>
  )
}

export default ShrimpSizeTablePage
